import dayjs, { Dayjs } from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);

export const getLastTwoWeeksRange = (): [Dayjs, Dayjs] => {
  const endOfLastWeek = dayjs().startOf('isoWeek').subtract(1, 'day');
  const startOfTwoWeeksAgo = endOfLastWeek.subtract(13, 'day');

  return [startOfTwoWeeksAgo, endOfLastWeek];
};

export const getLastWeekRange = (): [Dayjs, Dayjs] => {
  const endOfLastWeek = dayjs().startOf('isoWeek').subtract(1, 'day');
  const startOfLastWeek = endOfLastWeek.startOf('isoWeek');
  return [startOfLastWeek, endOfLastWeek];
};

export const getCurrentWeekRange = (): [Dayjs, Dayjs] => {
  const today = dayjs();
  const startOfWeek = today.startOf('isoWeek');
  return [startOfWeek, today];
};

export const getLastMonthRange = (): [Dayjs, Dayjs] => {
  const startOfLastMonth = dayjs().startOf('month').subtract(1, 'month');
  const endOfLastMonth = dayjs().startOf('month').subtract(1, 'day');
  return [startOfLastMonth, endOfLastMonth];
};

export const getCurrentMonthRange = (): [Dayjs, Dayjs] => {
  const today = dayjs();
  const startOfMonth = today.startOf('month');
  return [startOfMonth, today];
};
